import { render } from "./Cita_EspeCita.vue?vue&type=template&id=a98b99d0"
import script from "./Cita_EspeCita.vue?vue&type=script&lang=js"
export * from "./Cita_EspeCita.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__